import noHurtSvg from '../icons/svg/noHurtSvg.svg'
import hurtsLittleBitSvg from '../icons/svg/hurtsLittleBitSvg.svg'
import hurtsLittleMoreSvg from '../icons/svg/hurtsLittleMoreSvg.svg'
import hurtsEvenMoreSvg from '../icons/svg/hurtsEvenMoreSvg.svg'
import hurtsWholeLotSvg from '../icons/svg/hurtsWholeLotSvg.svg'
import hurtsWorstSvg from '../icons/svg/hurtsWorstSvg.svg'

export const DOCTOR_NOTES_UI_FIELDS = [
    {
        parentFieldLabel: 'Patient Detail Initial Assessment',
        id: 'pat-detail-initial',
        flexDir: 'column',
        childGap: 'childgap',
        childField: [
            {
                name: "comorbidityComplaint",
                label: "Complaint",
                type: 'textarea',
                id: 'complaint-id'
            },
            {
                name: "comorbidityObsAndFindings",
                label: "Observations and Findings",
                type: 'select',
                id: 'obsandfindings',
                semanticTag: 'finding',
                options: []
            },
            {
                name: 'comorbidityAllergies',
                label: 'Allergies',
                type: 'select',
                id: 'allergies-id',
                semanticTag: 'finding',
                options: []
            },
            {
                name: 'comorbidityMedicalHistory',
                label: 'Medical History',
                type: 'select',
                id: 'medical-history-id',
                semanticTag: 'situation',
                options: []
            },
            {
                name: 'comorbidityFamilyHistory',
                label: 'Family History',
                type: 'select',
                id: 'family-history',
                semanticTag: 'situation',
                options: []
            },
            {
                name: 'comorbidityMedicationHistory',
                label: 'Medication History',
                type: 'select',
                id: 'medication-history-id',
                semanticTag: 'product',
                options: []
            },
            {
                name: 'comorbidityOther',
                label: 'Other',
                id: 'patient-det-other-id',
                type: 'textarea',
            },
        ]
    },
    {
        parentFieldLabel: 'Dietary Pattern*',
        id: 'dietary-pattern-par-id',
        display: 'grid',
        name: 'dietaryPatternPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'dietaryPatternVeg',
                id: 'dietaryPattern1',
                label: 'Veg',
                type: 'radio',
                commonRadioName: 'dietary-pattern'
            },
            {
                name: 'dietaryPatternVegNonVeg',
                id: 'dietaryPattern2',
                label: 'Veg-Non Veg',
                type: 'radio',
                commonRadioName: 'dietary-pattern'
            },
            {
                name: 'dietaryPatternNonVeg',
                id: 'dietaryPattern3',
                label: 'Non Veg',
                type: 'radio',
                commonRadioName: 'dietary-pattern'
            },
        ]
    },
    {
        parentFieldLabel: 'Addiction*',
        id: 'addiction-par-id',
        display: 'grid',
        name: 'addictionPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'addictionSmoking',
                id: 'addiction1',
                label: 'Smoking',
                type: 'radio',
                commonRadioName: 'addiction-pattern'
            },
            {
                name: 'addictionAlcohol',
                id: 'addiction2',
                label: 'Alcohol',
                type: 'radio',
                commonRadioName: 'addiction-pattern'
            },
            {
                name: 'addictionSmokeAndAlcohol',
                id: 'addiction3',
                label: 'Smoking and Alcohol',
                type: 'radio',
                commonRadioName: 'addiction-pattern'
            },
            {
                name: 'addictionDrugs',
                id: 'addiction3',
                label: 'Drugs',
                type: 'radio',
                commonRadioName: 'addiction-pattern'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'hr-nibp-temp-par-id',
        display: 'grid',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'vitalHR',
                id: 'HR-1',
                label: 'HR',
                type: 'input',
            },
            {
                name: 'vitalNIBP',
                id: 'NIBP-1',
                label: 'NIBP',
                type: 'input',
            },
            {
                name: 'vitalTEMP',
                id: 'TEMP-1',
                label: 'TEMP',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'level-of-hurt-par-id',
        display: 'grid',
        name: 'painLevelPar',
        childGap: 'childgap',
        templateCol: 'grid6',
        childField: [
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'noHurt',
                id: 'level-pain-no-hurt',
                label: 'No Hurt',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: "0",
                img: noHurtSvg,
            },
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'littleBit',
                id: 'level-pain-little-bit',
                label: 'Hurts Little Bit',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: "2",
                img: hurtsLittleBitSvg,
            },
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'hurtsLittleMore',
                id: 'level-pain-little-more',
                label: 'Hurts Little More',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: "4",
                img: hurtsLittleMoreSvg,
            },
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'hurtsEvenMore',
                id: 'level-pain-even-more',
                label: 'Hurts Even More',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: "6",
                img: hurtsEvenMoreSvg,
            },
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'hurtsWholeLot',
                id: 'level-pain-whole-lot',
                label: 'Hurts Whole Lot',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: '8',
                img: hurtsWholeLotSvg,

            },
            {
                childDisplay: 'child-flex',
                childFlexDir: 'child-flex-dir-col',
                name: 'hurtsWorst',
                id: 'level-pain-worst',
                label: 'Hurts Worst',
                type: 'radio',
                commonRadioName: 'level-of-hurt',
                hurtScore: '10',
                img: hurtsWorstSvg,
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'resp-exam-par-1',
        childField: [
            {
                name: 'respiratoryExamination',
                id: 'respiratory-examination-1',
                label: 'Respiratory Examination',
                type: 'input',
                readOnly: true,
            },
        ]
    },
    {
        parentFieldLabel: 'Abnormality in Chest Wall',
        id: 'abnorm-chest-par-1',
        display: 'grid',
        name: 'abnormalityInChestWallPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        semanticTag: 'finding',
        childField: [
            {
                name: 'abnormalityInChestWall_Yes',
                id: 'abnorm-chest-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'abnorm-chest'
            },
            {
                name: 'abnormalityInChestWall_No',
                id: 'abnorm-chest-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'abnorm-chest'
            },
        ]
    },
    {
        parentFieldLabel: 'Air Entry',
        id: 'air-entry-par-1',
        display: 'grid',
        name: 'airEntryPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        semanticTag: 'finding',
        childField: [
            {
                name: 'airEntry_Yes',
                id: 'air-entry-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'air-entry-name'
            },
            {
                name: 'airEntry_No',
                id: 'air-entry-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'air-entry-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Any Abnormal Sound',
        id: 'any-abnorm-sound-par-1',
        display: 'grid',
        name: 'anyAbnormalSoundPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        semanticTag: 'finding',
        childField: [
            {
                name: 'anyAbnormalSound_Yes',
                id: 'abnorm-sound-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'abnorm-sound-name'
            },
            {
                name: 'anyAbnormalSound_No',
                id: 'abnorm-sound-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'abnorm-sound-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Use of Accessory Muscle',
        id: 'use-of-accessory-muscle-par-1',
        display: 'grid',
        name: 'useAccessoryMusclePar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'useAccessoryMuscle_Yes',
                id: 'use-muscle-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'use-muscle-name'
            },
            {
                name: 'useAccessoryMuscle_No',
                id: 'use-muscle-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'use-muscle-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'rr-spo2-par-1',
        display: 'grid',
        childGap: 'childgap',
        templateCol: 'grid2',
        childField: [
            {
                name: 'vitalRR',
                id: 'RR1',
                label: 'RR',
                type: 'input',
            },
            {
                name: 'vitalSPO2',
                id: 'SPO2',
                label: 'SPO2',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'cardiovascular-system-par-1',
        childField: [
            {
                name: 'cardiovascularSystem',
                id: 'Cardiovascular System-1',
                label: 'Cardiovascular System',
                type: 'input',
                readOnly: true,
            },
        ]
    },
    {
        parentFieldLabel: 'Heart Sound S1',
        id: 'heart-sound-par-1',
        display: 'grid',
        name: 'heartSoundS1Par',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'heartSoundS1_Yes',
                id: 'heart-sound-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'heart-sound-1-name'
            },
            {
                name: 'heartSoundS1_No',
                id: 'heart-sound-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'heart-sound-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Heart Sound S2',
        id: 'heart-sound-par-2',
        display: 'grid',
        name: 'heartSoundS2Par',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'heartSoundS2_Yes',
                id: 'heart-sound-2-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'heart-sound-2-name'
            },
            {
                name: 'heartSoundS2_No',
                id: 'heart-sound-2-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'heart-sound-2-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'findings-if-any-id',
        childField: [
            {
                name: 'cardiovasularFindingsAndDisorder',
                id: 'Findings and Disorder1',
                label: 'Findings and Disorder*',
                type: 'select',
                semanticTag: 'finding',
                options: []
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'remark-par-1',
        childField: [
            {
                name: 'cardiovasularFindingDisorderRemark',
                id: 'remark-1',
                label: 'Remark',
                type: 'textarea',
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'abdomen-par-1',
        childField: [
            {
                name: 'abdomen',
                id: 'abdomen-1',
                label: 'Abdomen',
                type: 'input',
                readOnly: true,
            },
        ]
    },
    {
        parentFieldLabel: 'Local Tenderness',
        id: 'local-tenderness-par-id-1',
        display: 'grid',
        name: 'abdomenLocalTendernessPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenLocalTenderness_Yes',
                id: 'local-tenderness-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'local-tenderness-1-name'
            },
            {
                name: 'abdomenLocalTenderness_No',
                id: 'local-tenderness-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'local-tenderness-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Guarding',
        id: 'guarding-par-id-1',
        display: 'grid',
        name: 'abdomenGaurdingPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenGaurding_Yes',
                id: 'guarding-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'guarding-1-name'
            },
            {
                name: 'abdomenGaurding_No',
                id: 'guarding-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'guarding-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Distension',
        id: 'distension-par-id-1',
        display: 'grid',
        name: 'abdomenDistentionPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenDistention_Yes',
                id: 'distension-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'distension-1-name'
            },
            {
                name: 'abdomenDistention_No',
                id: 'distension-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'distension-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Organo Megaly',
        id: 'organo-megaly-par-id-1',
        display: 'grid',
        name: 'abdomenOrganoMegalyPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenOrganoMegaly_Yes',
                id: 'organo-megaly-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'organo-megaly-1-name'
            },
            {
                name: 'organoMegaly_No',
                id: 'organo-megaly-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'organo-megaly-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Palpable Lump',
        id: 'palpable-lump-par-id-1',
        display: 'grid',
        name: 'abdomenPalpableLumpPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenPalpableLump_Yes',
                id: 'palpable-lump-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'palpable-lump-1-name'
            },
            {
                name: 'abdomenPalpableLump_No',
                id: 'palpable-lump-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'palpable-lump-1-name'
            },
        ]
    },
    {
        parentFieldLabel: 'Finding of auscultation of abdomen',
        id: 'finding-auscultation-par-id-1',
        display: 'grid',
        name: 'abdomenFindingAusculationAbdomenPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'abdomenFindingAusculationAbdomen_Yes',
                id: 'finding-auscultation-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'finding-auscultation-1-name'
            },
            {
                name: 'abdomenFindingAusculationAbdomen_No',
                id: 'finding-auscultation-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'finding-auscultation-1-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'CNS-par-id-1',
        childField: [
            {
                name: 'centralNervousSystem',
                id: 'CNS_INPUT-1',
                label: 'Central Nervous System',
                type: 'input',
                readOnly: true,
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'pupil-size-rl-par-id',
        display: 'grid',
        name: 'pupilSizeRightPar',
        childGap: 'childgap',
        templateCol: 'grid2',
        childField: [
            {
                name: 'pupilSizeRight',
                id: 'pupilSizeRight1',
                label: 'Pupil Size Right',
                type: 'select',
                options: [
                    {
                        name: 'Normal',
                        label: 'Normal',
                        id: 'normal-pp-rl-1'
                    },
                    {
                        name: 'Small',
                        label: 'Small',
                        id: 'normal-pp-rl-2'
                    },
                    {
                        name: 'Large',
                        label: 'Large',
                        id: 'normal-pp-rl-3'
                    },
                    {
                        name: 'Pinpoint',
                        label: 'Pinpoint',
                        id: 'normal-pp-rl-4'
                    },
                ]
            },
            {
                name: 'pupilSizeLeft',
                id: 'pupilSizeLeft1',
                label: 'Pupil Size Left',
                type: 'select',
                options: [
                    {
                        name: 'Normal',
                        label: 'Normal',
                        id: 'normal-pp-ll-1'
                    },
                    {
                        name: 'Small',
                        label: 'Small',
                        id: 'normal-pp-ll-2'
                    },
                    {
                        name: 'Large',
                        label: 'Large',
                        id: 'normal-pp-ll-3'
                    },
                    {
                        name: 'Pinpoint',
                        label: 'Pinpoint',
                        id: 'normal-pp-ll-4'
                    },
                ]
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'pupil-reaction-par-id-1',
        display: 'grid',
        name: 'pupilReactionRightPar',
        childGap: 'childgap',
        templateCol: 'grid2',
        childField: [
            {
                name: 'pupilReactionRight',
                id: 'pupilReactionRight1',
                label: 'Pupil Reaction Right',
                type: 'select',
                options: [
                    {
                        name: 'Reactive',
                        label: 'Reactive',
                        id: 'normal-pp-right-1'
                    },
                    {
                        name: 'Non-Reactive',
                        label: 'Non-Reactive',
                        id: 'normal-pp-right-2'
                    },
                ]
            },
            {
                name: 'pupilReactionLeft',
                id: 'pupilReactionLeft1',
                label: 'Pupil Reaction Left',
                type: 'select',
                options: [
                    {
                        name: 'Reactive',
                        label: 'Reactive',
                        id: 'normal-pp-rr-1'
                    },
                    {
                        name: 'Non-Reactive',
                        label: 'Non-Reactive',
                        id: 'normal-pp-rr-2'
                    },
                ]
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'gcs-score-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        childField: [
            {
                name: 'gcsScore',
                id: 'gcs-score-id-1',
                label: 'GCS Score',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: 'Neck Rigidity',
        id: 'neck-rigidity-par-id-1',
        display: 'grid',
        name: 'neckRigidityPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'neckRigidity_Yes',
                id: 'neck-rigidity-1-yes',
                label: 'Yes',
                type: 'radio',
                commonRadioName: 'neck-rigidity-1-name'
            },
            {
                name: 'neckRigidity_No',
                id: 'neck-rigidity-1-no',
                label: 'No',
                type: 'radio',
                commonRadioName: 'neck-rigidity-1-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'motor-power-arm-par-id-1',
        display: 'grid',
        name: 'motorPowerRightArmPar',
        childGap: 'childgap',
        templateCol: 'grid2',
        childField: [
            {
                name: 'motorPowerRightArm',
                id: 'motorPowerRightArm1',
                label: 'Motor Power Right Arm',
                type: 'select',
                options: [
                    {
                        name: 'Grade 0',
                        label: 'Grade 0 (G0)',
                        id: 'grade-l-0'
                    },
                    {
                        name: 'Grade 1',
                        label: 'Grade 1 (G1)',
                        id: 'grade-l-1'
                    },
                    {
                        name: 'Grade 2',
                        label: 'Grade 2 (G2)',
                        id: 'grade-l-2'
                    },
                    {
                        name: 'Grade 3',
                        label: 'Grade 3 (G3)',
                        id: 'grade-l-3'
                    },
                    {
                        name: 'Grade +4',
                        label: 'Grade+4 (G+4)',
                        id: 'grade-l-4-plus'
                    },
                    {
                        name: 'Grade 4',
                        label: 'Grade 4 (G4)',
                        id: 'grade-l-4'
                    },
                    {
                        name: 'Grade -4',
                        label: 'Grade -4 (G-4)',
                        id: 'grade-l-minus4'
                    },
                    {
                        name: 'Grade 5',
                        label: 'Grade 5 (G5)',
                        id: 'grade-l-5'
                    },
                ]
            },
            {
                name: 'motorPowerLeftArm',
                id: 'motorPowerLeftArm1',
                label: 'Motor Power Left Arm',
                type: 'select',
                options: [
                    {
                        name: 'Grade 0',
                        label: 'Grade 0 (G0)',
                        id: 'grade-a-0'
                    },
                    {
                        name: 'Grade 1',
                        label: 'Grade 1 (G1)',
                        id: 'grade-a-1'
                    },
                    {
                        name: 'Grade 2',
                        label: 'Grade 2 (G2)',
                        id: 'grade-a-2'
                    },
                    {
                        name: 'Grade 3',
                        label: 'Grade 3 (G3)',
                        id: 'grade-a-3'
                    },
                    {
                        name: 'Grade +4',
                        label: 'Grade+4 (G+4)',
                        id: 'grade-a-4-plus'
                    },
                    {
                        name: 'Grade 4',
                        label: 'Grade 4 (G4)',
                        id: 'grade-a-4'
                    },
                    {
                        name: 'Grade -4',
                        label: 'Grade -4 (G-4)',
                        id: 'grade-a-minus4'
                    },
                    {
                        name: 'Grade 5',
                        label: 'Grade 5 (G5)',
                        id: 'grade-a-5'
                    },
                ]
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'motor-power-leg-par-id-1',
        display: 'grid',
        name: 'motorPowerRightLegPar',
        childGap: 'childgap',
        templateCol: 'grid2',
        childField: [
            {
                name: 'motorPowerRightLeg',
                id: 'motorPowerRightLeg1',
                label: 'Motor Power Right Leg',
                type: 'select',
                options: [
                    {
                        name: 'Grade 0',
                        label: 'Grade 0 (G0)',
                        id: 'grade-rt-0'
                    },
                    {
                        name: 'Grade 1',
                        label: 'Grade 1 (G1)',
                        id: 'grade-rt-1'
                    },
                    {
                        name: 'Grade 2',
                        label: 'Grade 2 (G2)',
                        id: 'grade-rt-2'
                    },
                    {
                        name: 'Grade 3',
                        label: 'Grade 3 (G3)',
                        id: 'grade-rt-3'
                    },
                    {
                        name: 'Grade +4',
                        label: 'Grade+4 (G+4)',
                        id: 'grade-rt-4-plus'
                    },
                    {
                        name: 'Grade 4',
                        label: 'Grade 4 (G4)',
                        id: 'grade-rt-4'
                    },
                    {
                        name: 'Grade -4',
                        label: 'Grade -4 (G-4)',
                        id: 'grade-rt-minus4'
                    },
                    {
                        name: 'Grade 5',
                        label: 'Grade 5 (G5)',
                        id: 'grade-rt-5'
                    },
                ]
            },
            {
                name: 'motorPowerLeftLeg',
                id: 'motorPowerLeftLeg1',
                label: 'Motor Power Left Leg',
                type: 'select',
                options: [
                    {
                        name: 'Grade0',
                        label: 'Grade 0 (G0)',
                        id: 'grade-left-leg-0'
                    },
                    {
                        name: 'Grade 1',
                        label: 'Grade 1 (G1)',
                        id: 'grade-left-leg-1'
                    },
                    {
                        name: 'Grade 2',
                        label: 'Grade 2 (G2)',
                        id: 'grade-left-leg-2'
                    },
                    {
                        name: 'Grade 3',
                        label: 'Grade 3 (G3)',
                        id: 'grade-left-leg-3'
                    },
                    {
                        name: 'Grade +4',
                        label: 'Grade+4 (G+4)',
                        id: 'grade-left-leg-4-plus'
                    },
                    {
                        name: 'Grade 4',
                        label: 'Grade 4 (G4)',
                        id: 'grade-left-leg-4'
                    },
                    {
                        name: 'Grade -4',
                        label: 'Grade -4 (G-4)',
                        id: 'grade-left-leg-minus4'
                    },
                    {
                        name: 'Grade 5',
                        label: 'Grade 5 (G5)',
                        id: 'grade-left-leg-5'
                    },
                ]
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'sensation-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        childField: [
            {
                name: 'sensation',
                id: 'sensation-id-1',
                label: 'Sensation',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'reflexes-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        childField: [
            {
                name: 'reflexes',
                id: 'reflexes-id-1',
                label: 'Reflexes',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: 'Examination Of Cranial Nerves',
        id: 'examination-cranial-nerves-par-id-1',
        display: 'grid',
        name: 'examinationOfCranialNervesPar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'examinationOfCranialNerves_Normal',
                id: 'examination-cranial-nerves-id-1-normal',
                label: 'Normal',
                type: 'radio',
                commonRadioName: 'exam-of-cranial-nerves-1-name'
            },
            {
                name: 'examinationOfCranialNerves_Abnormal',
                id: 'examination-cranial-nerves-id-1-abnormal',
                label: 'Abnormal',
                type: 'radio',
                commonRadioName: 'exam-of-cranial-nerves-1-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'provisional-diagnosis-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        semanticTag: 'diagnosis',
        childField: [
            {
                name: 'provisionalDiagnosis',
                id: 'provisional-diagnosis-id-1',
                label: 'Provisional Diagnosis',
                type: 'select',
                apiCall: 'diagnosis'

            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'medical-treatment-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        childField: [
            {
                name: 'medicalTreatment',
                id: 'medical-treatment-id-1',
                label: 'Medical Treatment',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'surgical-treatment-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        childField: [
            {
                name: 'surgicalTreatment',
                id: 'surgical-treatment-id-1',
                label: 'Surgical Treatment',
                type: 'input',
            },
        ]
    },
    {
        parentFieldLabel: 'Treatment Objectives',
        id: 'treatment-objectives-par-id-1',
        display: 'grid',
        name: 'treatmentObjectivePar',
        childGap: 'childgap',
        templateCol: 'grid4',
        childField: [
            {
                name: 'treatmentObjectivesCure',
                id: 'treatment-objectives-id-1',
                label: 'Cure',
                type: 'radio',
                commonRadioName: 'treatment-radio-com-name'
            },
            {
                name: 'treatmentObjectivesRemission',
                id: 'treatment-objectives-id-1',
                label: 'Remission',
                type: 'radio',
                commonRadioName: 'treatment-radio-com-name'
            },
            {
                name: 'treatmentObjectivesSteadyState',
                id: 'treatment-objectives-id-1',
                label: 'Steady State',
                type: 'radio',
                commonRadioName: 'treatment-radio-com-name'
            },
            {
                name: 'treatmentObjectivesPalliation',
                id: 'treatment-objectives-id-1',
                label: 'Palliation',
                type: 'radio',
                commonRadioName: 'treatment-radio-com-name'
            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'medical-prescription-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        semanticTag: 'product',
        childField: [
            {
                name: 'medicalPrescription',
                id: 'medical-prescriptions-id-1',
                label: 'Medical Prescription',
                type: 'select',

            },
        ]
    },
    {
        parentFieldLabel: '',
        id: 'lab-orders-par-id-1',
        display: 'grid',
        childGap: 'childgap',
        semanticTag: 'procedure',
        childField: [
            {
                name: 'labOrders',
                id: 'lab-orders-id-1',
                label: 'Lab Orders',
                type: 'select',

            },
        ]
    },
]

export const NOTE_INPUT_TYPE = {
    RADIO: 'radio',
    TEXTAREA: 'textarea',
    SELECT: 'select',
    INPUT: 'input',
    DETAILS: 'DETAILS',
    SELECT_DETAIL: 'SELECT_DETAIL',
    DIAGNOSIS: 'diagnosis'

}
export const NOTE_YES_NO = {
    YES: "Yes",
    NO: 'No',
    ABNORMAL: 'Abnormal'
}